import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/activity/mutationTypes';

export default {
  [types.SET_ACTIVITIES]: createSetPropMutation('activities'),
  [types.SET_ACTIVITIES_LOADING]: createSetPropMutation('activitiesLoading', false),
  [types.CLEAR_ACTIVITIES]: createClearPropMutation('activities', []),
  [types.SET_ACTIVITY_DATA]: createSetPropMutation('activityData'),
  [types.CLEAR_ACTIVITY_DATA]: createClearPropMutation('activityData', null),
  [types.SET_REPORT_ACTIVITIES]: createSetPropMutation('reportActivities', []),
  [types.CLEAR_REPORT_ACTIVITIES]: createClearPropMutation('reportActivities', []),
};
